import axios from "axios";
import {
  setAlertWithTitle,
  setSessionExpired,
  setSpinnerLoading,
} from "./Redux/modal";
export const FontSizeWidth = (width) => {
  if (width < 500) {
    return 11;
  }
  if (width < 1281) {
    return 12;
  } else {
    return 14;
  }
};

export function toProperCase(str) {
  return str
    .toLowerCase()
    .replace(/(^|\s)\S/g, (letter) => letter.toUpperCase());
}
export const formatMobileNumber = (number) => {
  const cleaned = ("" + number).replace(/\D/g, ""); // Remove non-digit characters

  if (cleaned.length === 10) {
    // Format for Indian 10-digit number
    const match = cleaned.match(/^(\d{5})(\d{5})$/);
    if (match) {
      return match[1] + " " + match[2];
    }
  } else {
    return number;
  }

  // Return the original number if it doesn't match any format
};

export const CallAPI = (path, data, token, then, dispatch, final, c) => {
  axios
    .post(path, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((t) => {
      then(t);
      if (t?.data?.error) {
        console.log("err");
        dispatch(setSpinnerLoading(false));
      }
    })
    .catch((error) => {
      // dispatch(setSpinnerLoading(false));
      console.log(error);

      if (error.response.data.name === "TokenExpiredError") {
        dispatch(setSessionExpired(true));
      } else {
        if (c) {
          c(error);
        } else {
          dispatch(
            setAlertWithTitle({
              title: "Error",
              msg: "Something went wrong",
            })
          );
        }
      }
    })
    .finally(final ? final : () => {});
};
